import { cn } from "@/lib/utils";
import { createContentPortal } from "../../lib/create-content-portal";
import Logo from "../Logo/Logo";
import { useSidebar } from "../ui/sidebar";
import { AppTopRightMenu } from "./AppTopRightMenu";

const { ContentContainer, ContentPortal } = createContentPortal(
  "AppTopBarContentContainer",
);

export const AppTopBar = () => {
  const { setOpen, open } = useSidebar();

  return (
    <div
      className={cn(
        "absolute w-full",
        "flex h-16 items-center gap-4 px-4",
        "transition-top duration-500 ease-in-out",
        {
          "top-0": !open,
          "-top-16": open,
        },
      )}
    >
      <button
        onClick={() => setOpen(true)}
        className={cn(
          "border-accent-secondary flex h-12 w-12 items-center justify-center rounded-full border-2 p-0 text-white",
          "cursor-pointer",
          "transition-[transform, background-color] duration-400 ease-in-out hover:scale-120",
        )}
        aria-label="Open Sidebar"
        title="Open Sidebar"
      >
        <Logo size={100} />
      </button>
      <div className="flex flex-1 flex-row items-center justify-between gap-4 overflow-hidden">
        <ContentContainer className="flex flex-row items-center gap-2 overflow-hidden" />
        <AppTopRightMenu.TopBarContentContainer className="flex flex-row items-center gap-2" />
      </div>
    </div>
  );
};

const AppTopBarBufferContainer = () => {
  const { open } = useSidebar();

  return (
    <div
      className={cn("transition-[min-height] duration-500 ease-in-out", {
        "min-h-0": open,
        "min-h-16": !open,
      })}
    />
  );
};

AppTopBar.BufferContainer = AppTopBarBufferContainer;
AppTopBar.ContentPortal = ContentPortal;
